<template>
  <div>
    <div v-if="!showNoResults && scope === 'all'">
      <div v-if="displayPriority === 'products'">
        <div class="row mb-4 p-2 bg-white" v-if="products.length > 0">
          <pc-site-search-products-result :products="products" />
        </div>
        <div class="row mb-4 p-2 bg-white" v-if="collections.length > 0">
          <pc-site-search-collections-result :collections="collections" />
        </div>
      </div>
      <div v-else>
        <div class="row mb-4 p-2 bg-white" v-if="collections.length > 0">
          <pc-site-search-collections-result :collections="collections" />
        </div>
        <div class="row mb-4 p-2 bg-white" v-if="products.length > 0">
          <pc-site-search-products-result :products="products" />
        </div>
      </div>
      <div v-if="pages.length > 0">
        <pc-site-search-pages-result v-for="page in pages"
                                     :key="page.id"
                                     :page="page" />
      </div>
    </div>
    <div v-if="!showNoResults && scope != 'all'">
      <div class="row mb-4 p-2 bg-white" v-if="scope === 'collections'">
        <pc-site-search-collections-result
          v-if="collections.length > 0"
          :collections="collections"
        />
        <p v-else>{{ $resourceString["common.noResults"] }}</p>
      </div>
      <div class="row mb-4 p-2 bg-white" v-if="scope === 'styles'">
        <pc-site-search-products-result
          v-if="products.length > 0"
          :products="products"
        />
        <p v-else>{{ $resourceString["common.noResults"] }}</p>
      </div>
      <div v-if="scope === 'pages'">
        <div v-if="pages.length > 0">
          <pc-site-search-pages-result
            v-for="page in pages"
            :key="page.id"
            :page="page"
          />
        </div>
        <p v-else>{{ $resourceString["common.noResults"] }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import PcSiteSearchProductsResult from "./pc-site-search-products-result.vue";
import PcSiteSearchCollectionsResult from "./pc-site-search-collections-result.vue";
import PcSiteSearchPagesResult from "./pc-site-search-pages-result.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    PcSiteSearchProductsResult,
    PcSiteSearchCollectionsResult,
    PcSiteSearchPagesResult
  },
  computed: {
    ...mapGetters({
      scope: "searchMenu/scope",
      collections: "searchMenu/collections",
      pages: "searchMenu/pages",
      products: "searchMenu/products",
      showNoResults: "searchMenu/showNoResults",
      displayPriority: "searchMenu/displayPriority"
    })
  }
};
</script>

<style></style>
